import { VpActionChip } from '@vtmn-play/react'
import { VpGroupIcon, VpStoreIcon } from '@vtmn-play/icons/react'
import { useTranslation } from 'react-i18next'
import { StoreTeamSwitchAggregation } from '../state/home-context'

interface StoreTeamSwitchProps {
  onSelect: (value: StoreTeamSwitchAggregation) => void
  value?: StoreTeamSwitchAggregation
}

const isTeam = (storeTeamSwitchAggregation: StoreTeamSwitchAggregation) => storeTeamSwitchAggregation === 'TEAM'
const isStore = (storeTeamSwitchAggregation: StoreTeamSwitchAggregation) => storeTeamSwitchAggregation === 'STORE'

const StoreTeamSwitch = ({ onSelect, value = 'STORE' }: StoreTeamSwitchProps) => {
  const { t } = useTranslation()
  return (
    <div data-testid="store-team-switch">
      <div className="mg-store-team-switch">
        <VpActionChip
          size="medium"
          className={isStore(value) ? 'mg-store-team-switch-chip' : 'mg-store-team-switch-chip disabled'}
          data-testid="store-team-switch-store"
          onClick={() => {
            onSelect('STORE')
          }}
        >
          <VpStoreIcon fontSize="16" />
          <span className="mg-store-team-switch-chip-text vp-body-s">{t('general.homepage.store')}</span>
        </VpActionChip>
        <VpActionChip
          size="medium"
          className={isTeam(value) ? 'mg-store-team-switch-chip' : 'mg-store-team-switch-chip disabled'}
          data-testid="store-team-switch-team"
          onClick={() => {
            onSelect('TEAM')
          }}
        >
          <VpGroupIcon fontSize="16" />
          <span className="mg-store-team-switch-chip-text vp-body-s">{t('general.homepage.team')}</span>
        </VpActionChip>
      </div>
    </div>
  )
}

export default StoreTeamSwitch
